import {
  Box,
  Paper,
  Typography,
  Grid,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState, useEffect, useContext } from "react";
import { AppDataContext } from "../../../common/appContext";
import standingReach from "../../../icons/icons-NBAblue/standing-reach.png";
import wingSpan from "../../../icons/icons-NBAblue/wingspan-dimension.png";
import heightWithShoes from "../../../icons/icons-NBAblue/height-with-shoes.png";
import heightWithoutShoes from "../../../icons/icons-NBAblue/height-without-shoes.png";
import bodyWeight from "../../../icons/icons-NBAblue/weight.png";
import bodyFat from "../../../icons/icons-NBAblue/body-fat.png";
import handDimension from "../../../icons/icons-NBAblue/hand-dimensions.png";
import { PlayerProfileService } from "./../../../services/playerProfile.Service";
import PlayerProfileChartAnthro from "./PlayerProfileChartAnthro";
import { isShowUnitDrawer } from "../../../configs/AppSettings";
import PlayerProfileBarChartAnthro from "./PlayerProfileBarChartAnthro";

//... Icons imports
import CameraOutdoorIcon from "@mui/icons-material/CameraOutdoor";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import BarChartIcon from "@mui/icons-material/BarChart";

//...
import SlidingPaneComponent from "../../../sharedComponents/SlidingPane/SlidingPane";
import AnthrosUploadFile from "./AnthrosUploadFile";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AnthrosUploadPlayerPHA from "./AnthrosUploadPlayerPHA";
import PlayerGroupedBarChart from "./PlayerGroupedBarChart";

const useStyles2 = makeStyles((theme) => ({
  playerCombineInfo: {
    color: "#333", //"#c8102e",
    fontSize: "0.775rem",
  },
  playerCombineValues: {
    fontWeight: "normal",
    fontSize: "12.5px",
    color: "#000",
  },
  btnselected: {
    backgroundColor: "#C8102E", //"#1d428a",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#C8102E",
    },
  },
  btnunselected: {
    backgroundColor: "#707070",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#707070",
    },
  },
  actionButton: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  BMICard: {
    padding: "1rem 0px",
  },
}));

export default function Anthropometry(props) {
  // const { eventID, playerID, styles } = props;
  const { playerID, styles } = props;

  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const classes2 = useStyles2();

  const [anthrosData, setAnthrosData] = useState({});
  const [playerYear, setplayerYear] = useState([{}]);
  const [anthrosDataRanking, setAnthrosDataRanking] = useState({});
  const [loadingMessage, setLoadingMessage] = useState("Loading...");
  const {
    user,
    selectedEventId,
    lengthUnits,
    weightUnits,
    setWeightUnits,
    setLengthUnits,
    getWeightUnitValue,
    getLengthUnitValue,
    getLengthUnitLabelType,
    getWeightUnitLabelType,
    getHandDimensionsUnitValue,
    getHandDimensionsUnitLabelType,
  } = useContext(AppDataContext);
  const [eventId, setEventId] = useState(selectedEventId);
  const [btn1, setbtn1] = useState(false);
  const [btn2, setbtn2] = useState(false);
  const [btn3, setbtn3] = useState(false);
  const [btn4, setbtn4] = useState(false);
  const [btn5, setbtn5] = useState(false);

  //...panel data holder
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isPHAPanelOpen, setIsPHAPanelOpen] = useState(false);

  //... to toggle between chart and bar chart in anthropometry section
  const [viewType, setViewType] = useState("group");

  useEffect(() => {
    setEventId(selectedEventId);
    setbtn1(false);
    setbtn2(false);
    setbtn3(false);
    setbtn4(false);
    setbtn5(false);
  }, [selectedEventId]);

  useEffect(() => {
    if (isShowUnitDrawer) {
      setLengthUnits(4);
      setWeightUnits(1);
    }
  }, []);

  useEffect(() => {
    const fetchAnthroPreData = async () => {
      try {
        if (!user?.userName) return; // Check if user login ID is undefined

        const [anthrosData, anthrosDataRanking, playerYear] = await Promise.all(
          [
            PlayerProfileService.getAnthrosDataByPlayerId(
              eventId,
              playerID,
              user.userName
            ),
            PlayerProfileService.getAnthrosDataByPlayerIdRanking(
              eventId,
              playerID,
              user.userName
            ),
            PlayerProfileService.getAnthrosDataByPlayerYear(eventId, playerID),
          ]
        );

        setAnthrosData(anthrosData.data);
        setAnthrosDataRanking(anthrosDataRanking.data);
        setplayerYear(playerYear.data);

        const pdata = playerYear.data;
        pdata.map((item, index) => {
          if (item.eventId === selectedEventId + "" && index == 0) {
            setbtn1(true); //btn1=true;
          } else if (item.eventId === selectedEventId + "" && index == 1) {
            setbtn2(true); // btn2=true;
          } else if (item.eventId === selectedEventId && index == 2) {
            setbtn3(true); // btn2=true;
          } else if (item.eventId === selectedEventId && index == 3) {
            setbtn4(true); //btn4=true;
          } else if (item.eventId === selectedEventId && index == 4) {
            setbtn5(true); // btn5=true;
          }
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAnthroPreData();
  }, [eventId, user?.loginID]);

  const getyearValue = (playerEventId, index) => {
    if (index === 0) {
      setbtn1(true);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false);
      //  btn1=true;btn2=false;btn3=false;btn4=false;btn5=false;
    } else if (index === 1) {
      setbtn1(false);
      setbtn2(true);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=true;btn3=false;btn4=false;btn5=false;
    } else if (index === 2) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(true);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=false;btn3=true;btn4=false;btn5=false;
    } else if (index === 3) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(true);
      setbtn5(false); //btn1=false;btn2=false;btn3=false;btn4=true;btn5=false;
    } else if (index === 4) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(true); // btn1=false;btn2=false;btn3=false;btn4=false;btn5=true;
    }

    PlayerProfileService.getAnthrosDataByPlayerId(
      playerEventId,
      playerID,
      user?.userName
    ).then((response) => {
      setAnthrosData(response.data);
      if (Object.keys(response.data).length) {
      } else {
        setLoadingMessage("--");
      }
    });

    PlayerProfileService.getAnthrosDataByPlayerIdRanking(
      playerEventId,
      playerID,
      user?.userName
    ).then((response) => {
      setAnthrosDataRanking(response.data);
    });
  };

  const getDelimiterByValue = (value) =>
    (value > 0 ? "+" : "-") + Math.abs(value);

  const togglePanel = (open) => {
    setIsPanelOpen(open);
  };

  const togglePHAPanel = (open) => {
    setIsPHAPanelOpen(open);
  };

  // Validate given value is number or not
  const validateNumber = (num) =>
    Number.isInteger(Number(num)) ? Number(num) : Number(num).toFixed(2);

  // Define a reusable component for displaying label and value pair
  const LabelValuePair = ({
    label,
    dataHolder,
    value,
    loadingMessage,
    showIcon = false,
    iconComponent: IconComponent,
  }) => {
    return (
      <Box
        display="grid"
        gridTemplateColumns="215px auto"
        sx={{ paddingTop: "3px", paddingBottom: "3px" }}
      >
        <Box display="flex" alignItems="center" mr={1}>
          <img
            alt={label}
            src={bodyFat}
            height={17}
            width={17}
            style={{ color: "blue" }}
          />
          <Typography
            component="span"
            variant="subtitle2"
            sx={{ marginLeft: "5px" }}
          >
            {label}
          </Typography>
        </Box>

        <Box display="flex" alignItems="center">
          <Typography
            component="span"
            variant="subtitle2"
            sx={{ marginRight: "5px" }}
          >
            :
          </Typography>

          <Box display="flex" alignItems="center" gap={0.5}>
            <Typography
              component="span"
              variant="subtitle2"
              sx={{
                textAlign: "center",
                ...(showIcon && { marginTop: "5px" }),
              }}
            >
              {Object.keys(dataHolder).length ? (
                value === null || value === "" ? (
                  "--"
                ) : (
                  value
                )
              ) : (
                <span>{loadingMessage}</span>
              )}
            </Typography>

            {showIcon && IconComponent && (
              <Box
                component="span"
                sx={{ display: "flex", alignItems: "center" }}
              >
                <IconComponent size={22} />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Box p={2}>
        <Grid container alignItems="center">
          <Grid item sm={4} xs={12}>
            {" "}
            <Typography
              noWrap
              pl={1}
              variant={styles.gridSectionTitle.variant}
              //className={classes.gridSectionTitle}
              color="secondary"
              style={{ fontWeight: "500" }}
            >
              Anthropometry Summary
            </Typography>
          </Grid>
          <Grid item sm={8} xs={12}>
            {" "}
            <Box display="flex" alignItems={"center"} justifyContent="flex-end">
              {playerYear.length > 1
                ? playerYear.map((item, index) => {
                    if (index === 0) {
                      return (
                        <>
                          <Typography
                            variant="h6"
                            fontStyle="italic"
                            mr={2}
                            color={"primary"}
                            fontSize="14px"
                          >
                            Details available for{" "}
                          </Typography>
                          <Button
                            onClick={() => getyearValue(item.eventId, index)}
                            key={index}
                            className={
                              btn1 === true
                                ? classes2.btnselected
                                : classes2.btnunselected
                            }
                            size="small"
                          >
                            Year {item.eventYear}
                          </Button>
                        </>
                      );
                    } else if (index === 1) {
                      return (
                        <Button
                          onClick={() => getyearValue(item.eventId, index)}
                          key={index}
                          className={
                            btn2 === true
                              ? classes2.btnselected
                              : classes2.btnunselected
                          }
                          size="small"
                        >
                          Year {item.eventYear}
                        </Button>
                      );
                    } else if (index === 2) {
                      return (
                        <Button
                          onClick={() => getyearValue(item.eventId, index)}
                          key={index}
                          className={
                            btn3 === true
                              ? classes2.btnselected
                              : classes2.btndeselected
                          }
                          size="small"
                        >
                          Year {item.eventYear}
                        </Button>
                      );
                    } else if (index === 3) {
                      return (
                        <Button
                          onClick={() => getyearValue(item.eventId, index)}
                          key={index}
                          className={
                            btn4 === true
                              ? classes2.btnselected
                              : classes2.btnunselected
                          }
                          size="small"
                        >
                          Year {item.eventYear}
                        </Button>
                      );
                    } else if (index === 4) {
                      return (
                        <Button
                          onClick={() => getyearValue(item.eventId, index)}
                          key={index}
                          className={
                            btn5 === true
                              ? classes2.btnselected
                              : classes2.btnunselected
                          }
                          size="small"
                        >
                          Year {item.eventYear}
                        </Button>
                      );
                    } else {
                      return (
                        <Button
                          onClick={() => getyearValue(item.eventId, index)}
                          key={index}
                          className={
                            btn5 === true
                              ? classes2.btnselected
                              : classes2.btnunselected
                          }
                          size="small"
                        >
                          {item.eventYear}
                        </Button>
                      );
                    }
                  })
                : ""}

              {/* Anthropometry Upload option */}
              <TitleTooltip title={"View Media"} placement="left-start">
                <Button
                  variant="outlined"
                  className={classes.actionButton}
                  startIcon={<VisibilityIcon />}
                  onClick={() => togglePanel(true)}
                  sx={{ marginLeft: "10px" }}
                  size="small"
                >
                  View Media
                </Button>
              </TitleTooltip>

              {/* Anthropometry Upload option */}
              {Object.keys(anthrosData).length > 0 &&
                !anthrosData?.isTeamUserDataRestrict && (
                  <TitleTooltip
                    title={"View Bio-mechanical Documents"}
                    placement="left-start" // Note: Based on Top 10 player restrictions from the legal team.
                  >
                    <Button
                      variant="outlined"
                      className={classes.actionButton}
                      startIcon={<VisibilityIcon />}
                      onClick={() => togglePHAPanel(true)}
                      sx={{ marginLeft: "10px" }}
                      size="small"
                    >
                      View Bio-mechanical Documents
                    </Button>
                  </TitleTooltip>
                )}
            </Box>
          </Grid>
        </Grid>

        {/* <Button onClick={() => getyearValue(202309)} >2023</Button> */}
        <Grid
          container
          rowGap={3}
          sx={{
            margin: "15px 1px 10px 5px",
          }}
        >
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Box display="grid" gridTemplateColumns="210px 50px">
              <Box>
                <img
                  alt="standing-reach-ft"
                  src={standingReach}
                  height={17}
                  width={17}
                  style={{
                    color: "blue",
                    marginRight: "4px",
                  }}
                />
                <Typography
                  component="span"
                  variant="subtitle2"
                  className={classes2.playerCombineInfo}
                >
                  Standing Reach {getLengthUnitLabelType(lengthUnits)}
                </Typography>
              </Box>
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineValues}
              >
                {Object.keys(anthrosData).length ? (
                  anthrosData.standingReachFeet === null ||
                  anthrosData.standingReachFeet === "" ||
                  anthrosData.standingReachInches === null ||
                  anthrosData.standingReachInches === "" ? (
                    "--"
                  ) : (
                    getLengthUnitValue(
                      anthrosData.standingReachFeet,
                      anthrosData.standingReachInches
                    )
                  )
                ) : (
                  <span>{loadingMessage}</span>
                )}
              </Typography>
            </Box>
          </Grid>

          {/* Note:commenting the code for temporary  */}
          {/* <Grid item lg={3} md={6} sm={6} xs={12}>
          <Box display="grid" gridTemplateColumns="210px 50px">
            <Box>
              <img
                alt="height-with-shoes-ft"
                src={heightWithShoes}
                height={17}
                width={17}
                style={{
                  color: "blue",
                  marginRight: "4px",
                }}
              />
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineInfo}
              >
                Height (w/ shoes) {getLengthUnitLabelType(lengthUnits)}
              </Typography>
            </Box>
            <Typography
              component="span"
              variant="subtitle2"
              className={classes2.playerCombineValues}
            >
              {Object.keys(anthrosData).length ? (
                anthrosData.heightWithShoesFeet === null ||
                anthrosData.heightWithShoesFeet === "" ||
                anthrosData.heightWithShoesInches === null ||
                anthrosData.heightWithShoesInches === "" ? (
                  "--"
                ) : (
                  getLengthUnitValue(
                    anthrosData.heightWithShoesFeet,
                    anthrosData.heightWithShoesInches
                  )
                )
              ) : (
                <span>{loadingMessage}</span>
              )}
            </Typography>
          </Box>
        </Grid> */}

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Box display="grid" gridTemplateColumns="210px 50px">
              <Box>
                <img
                  alt="height-without-shoes-ft"
                  src={heightWithoutShoes}
                  height={17}
                  width={17}
                  style={{
                    color: "blue",
                    marginRight: "4px",
                  }}
                />
                <Typography
                  component="span"
                  variant="subtitle2"
                  className={classes2.playerCombineInfo}
                >
                  Height (w/o shoes) {getLengthUnitLabelType(lengthUnits)}
                </Typography>
              </Box>
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineValues}
              >
                {Object.keys(anthrosData).length ? (
                  anthrosData.heightWithOutShoesFeet === null ||
                  anthrosData.heightWithOutShoesFeet === "" ||
                  anthrosData.heightWithOutShoesInches === null ||
                  anthrosData.heightWithOutShoesInches === "" ? (
                    "--"
                  ) : (
                    getLengthUnitValue(
                      anthrosData.heightWithOutShoesFeet,
                      anthrosData.heightWithOutShoesInches
                    )
                  )
                ) : (
                  <span>{loadingMessage}</span>
                )}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Box display="grid" gridTemplateColumns="210px 50px">
              <Box>
                <img
                  alt="hand-width"
                  src={handDimension}
                  height={17}
                  width={17}
                  style={{
                    color: "blue",
                    marginRight: "4px",
                  }}
                />
                <Typography
                  component="span"
                  variant="subtitle2"
                  className={classes2.playerCombineInfo}
                >
                  Hand Width {getHandDimensionsUnitLabelType(lengthUnits)}
                </Typography>
              </Box>
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineValues}
              >
                {Object.keys(anthrosData).length ? (
                  anthrosData.handWidth === null ||
                  anthrosData.handWidth === "" ? (
                    "--"
                  ) : (
                    getHandDimensionsUnitValue(anthrosData.handWidth)
                  )
                ) : (
                  <span>{loadingMessage}</span>
                )}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Box display="grid" gridTemplateColumns="210px 50px">
              <Box>
                <img
                  alt="body-fat"
                  src={bodyFat}
                  height={17}
                  width={17}
                  style={{
                    color: "blue",
                    marginRight: "4px",
                  }}
                />
                <Typography
                  component="span"
                  variant="subtitle2"
                  className={classes2.playerCombineInfo}
                >
                  Body Fat Percentage
                </Typography>
              </Box>
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineValues}
              >
                {Object.keys(anthrosData).length ? (
                  anthrosData?.bodyFat === null ||
                  anthrosData?.bodyFat === "" ? (
                    "--"
                  ) : (
                    anthrosData.bodyFat
                  )
                ) : (
                  <span>{loadingMessage}</span>
                )}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Box
              display="grid"
              gridTemplateColumns={
                anthrosData?.wingSpanThreshhold ? "170px 90px" : "210px 50px"
              }
            >
              <Box>
                <img
                  alt="wing-span-ft"
                  src={wingSpan}
                  height={17}
                  width={17}
                  style={{
                    color: "blue",
                    marginRight: "4px",
                  }}
                />
                <Typography
                  component="span"
                  variant="subtitle2"
                  className={classes2.playerCombineInfo}
                >
                  Wingspan {getLengthUnitLabelType(lengthUnits)}
                </Typography>
              </Box>
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineValues}
              >
                {Object.keys(anthrosData).length ? (
                  anthrosData.wingSpanFeet === null ||
                  anthrosData.wingSpanFeet === "" ||
                  anthrosData.wingSpanInches === null ||
                  anthrosData.wingSpanInches === "" ? (
                    "--"
                  ) : (
                    <>
                      {getLengthUnitValue(
                        anthrosData.wingSpanFeet,
                        anthrosData.wingSpanInches
                      )}{" "}
                      <strong>
                        {anthrosData?.wingSpanThreshhold
                          ? `(${getDelimiterByValue(
                              anthrosData.wingSpanThreshhold
                            )})`
                          : ""}
                      </strong>
                    </>
                  )
                ) : (
                  loadingMessage
                )}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Box display="grid" gridTemplateColumns="210px 50px">
              <Box>
                <img
                  alt="body-weight"
                  src={bodyWeight}
                  height={17}
                  width={17}
                  style={{
                    color: "blue",
                    marginRight: "4px",
                  }}
                />
                <Typography
                  component="span"
                  variant="subtitle2"
                  className={classes2.playerCombineInfo}
                >
                  Body Weight {getWeightUnitLabelType(weightUnits)}
                </Typography>
              </Box>
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineValues}
              >
                {Object.keys(anthrosData).length ? (
                  anthrosData.bodyWeight === null ||
                  anthrosData.bodyWeight === "" ? (
                    "--"
                  ) : (
                    getWeightUnitValue(anthrosData.bodyWeight)
                  )
                ) : (
                  <span>{loadingMessage}</span>
                )}
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={3} md={6} sm={6} xs={12}>
            <Box display="grid" gridTemplateColumns="210px 50px">
              <Box>
                <img
                  alt="hand-length"
                  src={handDimension}
                  height={17}
                  width={17}
                  style={{
                    color: "blue",
                    marginRight: "4px",
                  }}
                />
                <Typography
                  component="span"
                  variant="subtitle2"
                  className={classes2.playerCombineInfo}
                >
                  Hand Length {getHandDimensionsUnitLabelType(lengthUnits)}
                </Typography>
              </Box>
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineValues}
              >
                {Object.keys(anthrosData).length ? (
                  anthrosData.handLength === null ||
                  anthrosData.handLength === "" ? (
                    "--"
                  ) : (
                    getHandDimensionsUnitValue(anthrosData.handLength)
                  )
                ) : (
                  <span>{loadingMessage}</span>
                )}
              </Typography>
            </Box>
          </Grid>

          {/* Note :: Hidden by client request */}
          {/* <Grid item lg={3} md={6} sm={6} xs={12}>
            <Box display="grid" gridTemplateColumns="210px 50px">
              <Box>
                <img
                  alt="body-fat"
                  src={bodyFat}
                  height={17}
                  width={17}
                  style={{
                    color: "blue",
                    marginRight: "4px",
                  }}
                />
                <Typography
                  component="span"
                  variant="subtitle2"
                  className={classes2.playerCombineInfo}
                >
                  DEXA Body Fat Percentage
                </Typography>
              </Box>
              <Typography
                component="span"
                variant="subtitle2"
                className={classes2.playerCombineValues}
              >
                {Object.keys(anthrosData).length ? (
                  anthrosData?.bodyFatDXA === null ||
                  anthrosData?.bodyFatDXA === "" ||
                  anthrosData?.isTeamUserDataRestrict ? (
                    "--"
                  ) : (
                    anthrosData.bodyFatDXA
                  )
                ) : (
                  <span>{loadingMessage}</span>
                )}
              </Typography>
            </Box>
          </Grid> */}
        </Grid>

        {/* Anthros BMI section */}
        {Object.keys(anthrosData).length > 0 &&
          !anthrosData?.isTeamUserDataRestrict && (
            <Box className="measure-bmi-container">
              <Paper
                elevation={3}
                sx={{ margin: "2rem 0px 1rem 0px", padding: "10px" }}
              >
                <Grid container rowGap={3}>
                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Hip Abduction Peak Force L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.hipAbductionPeakForceL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Hip Abduction Peak Force R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.hipAbductionPeakForceR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force L (RF-L)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.hipAbductionRelativeForceL?.toFixed(2) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force R (RF-R)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.hipAbductionRelativeForceR?.toFixed(2) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="%Difference"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.hipAbductionRelativeForcePercentageDiff?.toFixed(
                          2
                        ) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Femur L Length (cm)"
                      dataHolder={anthrosData}
                      value={anthrosData?.femurLLength || 0}
                      loadingMessage={loadingMessage}
                    />

                    <LabelValuePair
                      label="Femur R Length (cm)"
                      dataHolder={anthrosData}
                      value={anthrosData?.femurRLength || 0}
                      loadingMessage={loadingMessage}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Hip Adduction Peak Force L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.hipAdductionPeakForceL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Hip Adduction PeakForce R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.hipAdductionPeakForceR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force L (RF-L)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.hipAdductionRelativeForceL?.toFixed(2) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force R (RF-R)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.hipAdductionRelativeForceR?.toFixed(2) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="%Difference"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.hipAdductionRelativeForcePercentageDiff?.toFixed(
                          2
                        ) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Fibula L Length (cm)"
                      dataHolder={anthrosData}
                      value={anthrosData?.fibulaLLength || 0}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Fibula R Length (cm)"
                      dataHolder={anthrosData}
                      value={anthrosData?.fibulaRLength || 0}
                      loadingMessage={loadingMessage}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Knee Extension Peak Force L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.kneeExtensionPeakForceL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Knee Extension Peak Force R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.kneeExtensionPeakForceR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force L (RF-L)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.kneeExtensionRelativeForceL?.toFixed(2) ||
                        0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force R (RF-R)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.kneeExtensionRelativeForceR?.toFixed(2) ||
                        0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="%Difference"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.kneeExtensionRelativeForcePercentageDiff?.toFixed(
                          2
                        ) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Short Foot L Length (cm)"
                      dataHolder={anthrosData}
                      value={anthrosData?.shortFootLLength || 0}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Short Foot R Length (cm)"
                      dataHolder={anthrosData}
                      value={anthrosData?.shortFootRLength || 0}
                      loadingMessage={loadingMessage}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Knee Flexion Peak Force L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.kneeFlexionPeakForceL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Knee Flexion Peak Force R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.kneeFlexionPeakForceR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force L (RF-L)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.kneeFlexionRelativeForceL?.toFixed(2) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force R (RF-R)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.kneeFlexionRelativeForceR?.toFixed(2) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="%Difference"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.kneeFlexionRelativeForcePercentageDiff?.toFixed(
                          2
                        ) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Ankle Plantar Flexion PF-L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.anklePlantarFlexionPeakForceL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Ankle Plantar Flexion PF-R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData.anklePlantarFlexionPeakForceR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force L (RF-L)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.anklePlantarFlexionRelativeForceL?.toFixed(
                          2
                        ) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Relative Force R (RF-R)"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.anklePlantarFlexionRelativeForceR?.toFixed(
                          2
                        ) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="%Difference"
                      dataHolder={anthrosData}
                      value={
                        anthrosData?.anklePlantarFlexionRelativeForcePercentageDiff?.toFixed(
                          2
                        ) || 0
                      }
                      loadingMessage={loadingMessage}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item sm={12} xs={12} md={12} lg={12}>
                    <Typography
                      noWrap
                      variant={styles.gridSectionTitle.variant}
                      color="secondary"
                      style={{
                        fontWeight: "500",
                        borderBottom: "2px solid",
                        display: "inline",
                      }}
                    >
                      Torque
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Hip Abduction L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.hipAbductionTorqueL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Hip Abduction R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.hipAbductionTorqueR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                  </Grid>
                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Hip Adduction L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.hipAdductionTorqueL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Hip Adduction R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.hipAdductionTorqueR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                  </Grid>
                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Knee Extension L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.kneeExtensionTorqueL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Knee Extension R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.kneeExtensionTorqueR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                  </Grid>
                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Knee Flexion L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.kneeFlexionTorqueL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Knee Flexion R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.kneeFlexionTorqueR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                  </Grid>
                  <Grid
                    item
                    lg={2.4}
                    md={4}
                    sm={6}
                    xs={12}
                    className={classes2.BMICard}
                  >
                    <LabelValuePair
                      label="Ankle Plantar Flexion PF L"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.anklePlantarFlexionTorqueL || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                    <LabelValuePair
                      label="Ankle Plantar Flexion PF R"
                      dataHolder={anthrosData}
                      value={validateNumber(
                        anthrosData?.anklePlantarFlexionTorqueR || 0
                      )}
                      loadingMessage={loadingMessage}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          )}

        {/* Graps statistics */}
        <Box className="graph-statistics-container">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
            px={1}
          >
            <Box fontWeight={600} fontSize="16px">
              Anthropometric Statistics
            </Box>

            <Box
              display="flex"
              alignItems="center"
              sx={{
                background: "#f5f5f5",
                borderRadius: "12px",
                padding: "4px",
                boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <TitleTooltip title="Grouped Chart">
                <IconButton
                  onClick={() => setViewType("group")}
                  sx={{
                    mx: 0.5,
                    borderRadius: "10px",
                    transition: "all 0.2s ease",
                    backgroundColor:
                      viewType === "group" ? "#fff" : "transparent",
                    boxShadow:
                      viewType === "group"
                        ? "0 2px 6px rgba(0,0,0,0.15)"
                        : "none",
                    "&:hover": {
                      backgroundColor: "#fff",
                    },
                  }}
                >
                  <BarChartIcon
                    color={viewType === "group" ? "primary" : "action"}
                  />
                </IconButton>
              </TitleTooltip>
              <TitleTooltip title="Individual Charts">
                <IconButton
                  onClick={() => setViewType("individual")}
                  sx={{
                    mx: 0.5,
                    borderRadius: "10px",
                    transition: "all 0.2s ease",
                    backgroundColor:
                      viewType === "individual" ? "#fff" : "transparent",
                    boxShadow:
                      viewType === "individual"
                        ? "0 2px 6px rgba(0,0,0,0.15)"
                        : "none",
                    "&:hover": {
                      backgroundColor: "#fff",
                    },
                  }}
                >
                  <ViewModuleIcon
                    color={viewType === "individual" ? "primary" : "action"}
                  />
                </IconButton>
              </TitleTooltip>
            </Box>
          </Box>

          <Paper elevation={3} sx={{ margin: "20px 0 0", padding: "10px" }}>
            {viewType === "individual" && (
              <Grid container spacing={2}>
                <Grid item md={6} sm={12} xs={12} justifyContent="center">
                  <PlayerProfileBarChartAnthro
                    playervalue={getHandDimensionsUnitValue(
                      anthrosDataRanking.standingReachInches
                    )}
                    groupvalue={anthrosDataRanking.avG_StandingReachInches}
                    chartName={"Standing Reach"}
                    name={
                      anthrosDataRanking.playerName
                        ? anthrosDataRanking.playerName
                        : "Selected Player"
                    }
                    rank={`${anthrosDataRanking.standingReachInchesRank ?? 0}/${
                      anthrosDataRanking.tpcStandingReachInches ?? 0
                    }`}
                    isPlayerProfileChart={true}
                  />
                </Grid>

                <Grid item md={6} sm={12} xs={12} justifyContent="center">
                  <PlayerProfileBarChartAnthro
                    playervalue={getHandDimensionsUnitValue(
                      anthrosDataRanking.wingSpanInches
                    )}
                    groupvalue={anthrosDataRanking.avG_WingSpanInches}
                    chartName={"Wingspan "}
                    name={
                      anthrosDataRanking.playerName
                        ? anthrosDataRanking.playerName
                        : "Selected Player"
                    }
                    rank={`${anthrosDataRanking.wingSpanInchesRank ?? 0}/${
                      anthrosDataRanking.tpcWingSpanInches ?? 0
                    }`}
                    isPlayerProfileChart={true}
                  />
                </Grid>

                <Grid item md={6} sm={12} xs={12} justifyContent="center">
                  <PlayerProfileBarChartAnthro
                    playervalue={getHandDimensionsUnitValue(
                      anthrosDataRanking.heightWithOutShoesInches
                    )}
                    groupvalue={anthrosDataRanking.avG_HeightWithOutShoesInches}
                    chartName={"Height"}
                    name={
                      anthrosDataRanking.playerName
                        ? anthrosDataRanking.playerName
                        : "Selected Player"
                    }
                    rank={`${
                      anthrosDataRanking.heightWithOutShoesInchesRank ?? 0
                    }/${anthrosDataRanking.tpcHeightWithOutShoesInches ?? 0}`}
                    isPlayerProfileChart={true}
                  />
                </Grid>

                <Grid item md={6} sm={12} xs={12} justifyContent="center">
                  <PlayerProfileBarChartAnthro
                    playervalue={getWeightUnitValue(
                      anthrosDataRanking.bodyWeight
                    )}
                    groupvalue={anthrosDataRanking.avG_BodyWeight}
                    chartName={"Body Weight"}
                    name={
                      anthrosDataRanking.playerName
                        ? anthrosDataRanking.playerName
                        : "Selected Player"
                    }
                    rank={`${anthrosDataRanking.bodyWeightRank ?? 0}/${
                      anthrosDataRanking.tpcBodyWeight ?? 0
                    }`}
                    isPlayerProfileChart={true}
                  />
                </Grid>

                <Grid item md={6} sm={12} xs={12} justifyContent="center">
                  <PlayerProfileBarChartAnthro
                    playervalue={getHandDimensionsUnitValue(
                      anthrosDataRanking.handWidth
                    )}
                    groupvalue={anthrosDataRanking.avG_HandWidth}
                    chartName={"Hand Width"}
                    name={
                      anthrosDataRanking.playerName
                        ? anthrosDataRanking.playerName
                        : "Selected Player"
                    }
                    rank={`${anthrosDataRanking.handWidthRank ?? 0}/${
                      anthrosDataRanking.tpcHandWidth ?? 0
                    }`}
                    isPlayerProfileChart={true}
                  />
                </Grid>

                <Grid item md={6} sm={12} xs={12} justifyContent="center">
                  <PlayerProfileBarChartAnthro
                    playervalue={getHandDimensionsUnitValue(
                      anthrosDataRanking.handLength
                    )}
                    groupvalue={anthrosDataRanking.avG_HandLength}
                    chartName={"Hand Length"}
                    name={
                      anthrosDataRanking.playerName
                        ? anthrosDataRanking.playerName
                        : "Selected Player"
                    }
                    rank={`${anthrosDataRanking.handLengthRank ?? 0}/${
                      anthrosDataRanking.tpcHandLength ?? 0
                    }`}
                    isPlayerProfileChart={true}
                  />
                </Grid>

                {/* Note: Based on Top 10 player restrictions from the legal team. */}
                {Object.keys(anthrosDataRanking).length > 0 &&
                  !anthrosDataRanking?.isTeamUserDataRestrict && (
                    <>
                      <Grid item md={6} sm={12} xs={12} justifyContent="center">
                        <PlayerProfileBarChartAnthro
                          playervalue={anthrosDataRanking.bodyFat ?? 0}
                          groupvalue={anthrosDataRanking.avG_BodyFat ?? 0}
                          chartName={"Body Fat"}
                          name={
                            anthrosDataRanking.playerName
                              ? anthrosDataRanking.playerName
                              : "Selected Player"
                          }
                          rank={`${anthrosDataRanking.bodyFatRank ?? 0}/${
                            anthrosDataRanking.tpcBodyFat ?? 0
                          }`}
                          isPlayerProfileChart={true}
                        />
                      </Grid>

                      {/* <Grid item md={6} sm={12} xs={12} justifyContent="center">
                      <PlayerProfileBarChartAnthro
                        playervalue={anthrosDataRanking.bodyFatDXA ?? 0}
                        groupvalue={anthrosDataRanking.avG_BodyFatDXA ?? 0}
                        chartName={"DEXA Body Fat"}
                        name={
                          anthrosDataRanking.playerName
                            ? anthrosDataRanking.playerName
                            : "Selected Player"
                        }
                        rank={`${anthrosDataRanking.bodyFatDXARank ?? 0}/${
                          anthrosDataRanking.tpcBodyFatDXA ?? 0
                        }`}
                        isPlayerProfileChart={true}
                      />
                    </Grid> */}
                    </>
                  )}
              </Grid>
            )}

            {viewType === "group" && (
              <Grid container spacing={2}>
                <Grid item md={12} sm={12} xs={12}>
                  <Box display="flex" justifyContent="center">
                    <PlayerGroupedBarChart
                      playerName={
                        anthrosDataRanking.playerName
                          ? anthrosDataRanking.playerName
                          : "Selected Player"
                      }
                      dataProp={{
                        labels: [
                          "Standing Reach",
                          "Wingspan",
                          "Height",
                          "Body Weight",
                          "Hand Width",
                          "Hand Length",
                          ...(!anthrosDataRanking?.isTeamUserDataRestrict
                            ? ["Body Fat"]
                            : []),
                        ],
                        player: [
                          getHandDimensionsUnitValue(
                            anthrosDataRanking.standingReachInches
                          ),
                          getHandDimensionsUnitValue(
                            anthrosDataRanking.wingSpanInches
                          ),
                          getHandDimensionsUnitValue(
                            anthrosDataRanking.heightWithOutShoesInches
                          ),
                          getWeightUnitValue(anthrosDataRanking.bodyWeight),
                          getHandDimensionsUnitValue(
                            anthrosDataRanking.handWidth
                          ),
                          getHandDimensionsUnitValue(
                            anthrosDataRanking.handLength
                          ),
                          ...(!anthrosDataRanking?.isTeamUserDataRestrict
                            ? [anthrosDataRanking.bodyFat ?? 0]
                            : []),
                        ],
                        average: [
                          anthrosDataRanking.avG_StandingReachInches,
                          anthrosDataRanking.avG_WingSpanInches,
                          anthrosDataRanking.avG_HeightWithOutShoesInches,
                          anthrosDataRanking.avG_BodyWeight,
                          anthrosDataRanking.avG_HandWidth,
                          anthrosDataRanking.avG_HandLength,
                          ...(!anthrosDataRanking?.isTeamUserDataRestrict
                            ? [anthrosDataRanking.avG_BodyFat ?? 0]
                            : []),
                        ],
                        ranks: [
                          `${anthrosDataRanking.standingReachInchesRank ?? 0}/${
                            anthrosDataRanking.tpcStandingReachInches ?? 0
                          }`,
                          `${anthrosDataRanking.wingSpanInchesRank ?? 0}/${
                            anthrosDataRanking.tpcWingSpanInches ?? 0
                          }`,
                          `${
                            anthrosDataRanking.heightWithOutShoesInchesRank ?? 0
                          }/${
                            anthrosDataRanking.tpcHeightWithOutShoesInches ?? 0
                          }`,
                          `${anthrosDataRanking.bodyWeightRank ?? 0}/${
                            anthrosDataRanking.tpcBodyWeight ?? 0
                          }`,
                          `${anthrosDataRanking.handWidthRank ?? 0}/${
                            anthrosDataRanking.tpcHandWidth ?? 0
                          }`,
                          `${anthrosDataRanking.handLengthRank ?? 0}/${
                            anthrosDataRanking.tpcHandLength ?? 0
                          }`,
                          ...(!anthrosDataRanking?.isTeamUserDataRestrict
                            ? [
                                `${anthrosDataRanking.bodyFatRank ?? 0}/${
                                  anthrosDataRanking.tpcBodyFat ?? 0
                                }`,
                              ]
                            : []),
                        ],
                      }}
                    />
                  </Box>
                </Grid>
              </Grid>
            )}
          </Paper>
        </Box>
      </Box>

      <SlidingPaneComponent
        width="95%"
        className="slider-pane"
        overlayClassName="slider-pane-overlay"
        isOpen={isPanelOpen}
        title="Anthropometry : View Media"
        onRequestClose={() => togglePanel(false)}
        hideHeader
        closeIcon={<ArrowBackIosIcon style={{ width: "25px" }} />}
      >
        <AnthrosUploadFile
          playerData={anthrosData}
          setAnthrosData={setAnthrosData}
        />
      </SlidingPaneComponent>

      <SlidingPaneComponent
        width="95%"
        className="slider-pane"
        overlayClassName="slider-pane-overlay"
        isOpen={isPHAPanelOpen}
        title="Anthropometry : View Bio-Mechanical Documents"
        onRequestClose={() => togglePHAPanel(false)}
        hideHeader
        closeIcon={<ArrowBackIosIcon style={{ width: "25px" }} />}
      >
        <AnthrosUploadPlayerPHA playerData={anthrosData} />
      </SlidingPaneComponent>
    </>
  );
}
